// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Organizations.module.css */

/* Основные стили */
.Organizations_container__jjP90 {
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 15px 20px;
}

.Organizations_header__p6Qyn {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  position: sticky;
  top: -1px;
  background: white;
  z-index: 100;
  padding: 20px 0;
  margin-bottom: 25px;
  border-bottom: 1px solid #e0e0e0;
}

.Organizations_title__-ceuV {
  margin: 0;
  font-size: 1.8rem;
  color: #2c3e50;
  font-weight: 600;
}

.Organizations_addButton__Csa3x {
  background-color: #4CAF50;
  color: white;
  padding: 12px 25px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

.Organizations_addButton__Csa3x:hover {
  background-color: #43a047;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0,0,0,0.15);
}

.Organizations_addButton__Csa3x span {
  font-size: 1.2rem;
}

/* Стили таблицы */
.Organizations_table__FqdSF {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.Organizations_table__FqdSF th,
.Organizations_table__FqdSF td {
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.Organizations_table__FqdSF th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #495057;
}

.Organizations_table__FqdSF tr:hover {
  background-color: #f8f9fa;
}

.Organizations_actionsCell__yL4Os {
  white-space: nowrap;
}

/* Organizations.module.css */

.Organizations_leaderSearch__ZbC2R {
  position: relative;
  width: 100%;
}

.Organizations_searchContainer__B\\+XqL {
  position: relative;
}

.Organizations_searchInput__\\+w5Ct {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
}

.Organizations_searchResults__9HZA6 {
  position: absolute;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-top: 5px;
  z-index: 300;
}

.Organizations_searchResultItem__fg6qM {
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.Organizations_searchResultItem__fg6qM:hover {
  background-color: #f5f5f5;
}

.Organizations_loading__fab4a {
  padding: 10px;
  color: #666;
  font-style: italic;
}

.Organizations_editButton__MrJj\\+,
.Organizations_deleteButton__BM-4g {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
  margin-right: 8px;
}

.Organizations_editButton__MrJj\\+ {
  background-color: #2196F3;
  color: white;
}

.Organizations_deleteButton__BM-4g {
  background-color: #f44336;
  color: white;
}

.Organizations_editButton__MrJj\\+:hover {
  background-color: #1e88e5;
  transform: translateY(-1px);
}

.Organizations_deleteButton__BM-4g:hover {
  background-color: #e53935;
  transform: translateY(-1px);
}

/* Модальное окно */
.Organizations_modalOverlay__bK2-l {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 200;
}

.Organizations_modal__wB0lM {
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.Organizations_modal__wB0lM h3 {
  margin-top: 0;
  color: #2c3e50;
  margin-bottom: 25px;
}

.Organizations_formGroup__XxzsJ {
  margin-bottom: 20px;
}

.Organizations_formGroup__XxzsJ label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #495057;
}

.Organizations_formGroup__XxzsJ input,
.Organizations_formGroup__XxzsJ select,
.Organizations_formGroup__XxzsJ textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s;
}

.Organizations_formGroup__XxzsJ input:focus,
.Organizations_formGroup__XxzsJ select:focus,
.Organizations_formGroup__XxzsJ textarea:focus {
  border-color: #4CAF50;
  outline: none;
  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.1);
}

.Organizations_buttonGroup__3qzmB {
  display: flex;
  gap: 15px;
  margin-top: 25px;
}

.Organizations_saveButton__yD4Cx,
.Organizations_cancelButton__6JrrC {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
  flex: 1 1;
}

.Organizations_saveButton__yD4Cx {
  background-color: #4CAF50;
  color: white;
}

.Organizations_cancelButton__6JrrC {
  background-color: #6c757d;
  color: white;
}

.Organizations_saveButton__yD4Cx:hover {
  background-color: #43a047;
  transform: translateY(-1px);
}

.Organizations_cancelButton__6JrrC:hover {
  background-color: #5a6268;
  transform: translateY(-1px);
}

/* Адаптивные стили */
@media (max-width: 768px) {
  .Organizations_container__jjP90 {
    padding-top: 90px;
  }

  .Organizations_table__FqdSF {
    display: block;
    width: 100%;
    border-radius: 0;
    box-shadow: none;
  }

  .Organizations_table__FqdSF thead {
    display: none;
  }

  .Organizations_table__FqdSF tr {
    display: block;
    margin-bottom: 20px;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    padding: 15px;
    background: #f9f9f9;
  }

  .Organizations_table__FqdSF td {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 10px;
    border-bottom: 1px solid #eee;
  }

  .Organizations_table__FqdSF td:last-child {
    border-bottom: none;
  }

  .Organizations_table__FqdSF td::before {
    content: attr(data-label);
    font-weight: 500;
    margin-right: 15px;
    flex-basis: 40%;
    color: #495057;
  }

  .Organizations_actionsCell__yL4Os {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
  }

  .Organizations_modal__wB0lM {
    padding: 20px;
    border-radius: 12px;
  }
}

@media (max-width: 480px) {
  .Organizations_header__p6Qyn {
    flex-direction: column;
    align-items: stretch;
    padding: 15px 0;
  }

  .Organizations_addButton__Csa3x {
    width: 100%;
    padding: 14px;
    justify-content: center;
  }

  .Organizations_formGroup__XxzsJ input,
  .Organizations_formGroup__XxzsJ select,
  .Organizations_formGroup__XxzsJ textarea {
    padding: 10px;
  }

  .Organizations_buttonGroup__3qzmB {
    flex-direction: column;
    gap: 10px;
  }

  .Organizations_saveButton__yD4Cx,
  .Organizations_cancelButton__6JrrC {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AdminPage/Organizations/Organizations.module.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qCAAqC;EACrC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;;AAE7B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;;EAGE,qBAAqB;EACrB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,sCAAsC;IACtC,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":["/* Organizations.module.css */\r\n\r\n/* Основные стили */\r\n.container {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 100px 15px 20px;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 15px;\r\n  position: sticky;\r\n  top: -1px;\r\n  background: white;\r\n  z-index: 100;\r\n  padding: 20px 0;\r\n  margin-bottom: 25px;\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.title {\r\n  margin: 0;\r\n  font-size: 1.8rem;\r\n  color: #2c3e50;\r\n  font-weight: 600;\r\n}\r\n\r\n.addButton {\r\n  background-color: #4CAF50;\r\n  color: white;\r\n  padding: 12px 25px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  font-size: 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.addButton:hover {\r\n  background-color: #43a047;\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 6px rgba(0,0,0,0.15);\r\n}\r\n\r\n.addButton span {\r\n  font-size: 1.2rem;\r\n}\r\n\r\n/* Стили таблицы */\r\n.table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-bottom: 20px;\r\n  overflow: hidden;\r\n  border-radius: 12px;\r\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\r\n}\r\n\r\n.table th,\r\n.table td {\r\n  padding: 15px;\r\n  text-align: left;\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.table th {\r\n  background-color: #f8f9fa;\r\n  font-weight: 600;\r\n  color: #495057;\r\n}\r\n\r\n.table tr:hover {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.actionsCell {\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Organizations.module.css */\r\n\r\n.leaderSearch {\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.searchContainer {\r\n  position: relative;\r\n}\r\n\r\n.searchInput {\r\n  width: 100%;\r\n  padding: 12px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n}\r\n\r\n.searchResults {\r\n  position: absolute;\r\n  width: 100%;\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n  background: white;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  margin-top: 5px;\r\n  z-index: 300;\r\n}\r\n\r\n.searchResultItem {\r\n  padding: 10px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.searchResultItem:hover {\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.loading {\r\n  padding: 10px;\r\n  color: #666;\r\n  font-style: italic;\r\n}\r\n\r\n.editButton,\r\n.deleteButton {\r\n  padding: 8px 16px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  font-size: 0.9rem;\r\n  margin-right: 8px;\r\n}\r\n\r\n.editButton {\r\n  background-color: #2196F3;\r\n  color: white;\r\n}\r\n\r\n.deleteButton {\r\n  background-color: #f44336;\r\n  color: white;\r\n}\r\n\r\n.editButton:hover {\r\n  background-color: #1e88e5;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.deleteButton:hover {\r\n  background-color: #e53935;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n/* Модальное окно */\r\n.modalOverlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 200;\r\n}\r\n\r\n.modal {\r\n  background: white;\r\n  padding: 30px;\r\n  border-radius: 15px;\r\n  box-shadow: 0 10px 30px rgba(0,0,0,0.2);\r\n  width: 90%;\r\n  max-width: 500px;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n}\r\n\r\n.modal h3 {\r\n  margin-top: 0;\r\n  color: #2c3e50;\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.formGroup {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.formGroup label {\r\n  display: block;\r\n  margin-bottom: 8px;\r\n  font-weight: 500;\r\n  color: #495057;\r\n}\r\n\r\n.formGroup input,\r\n.formGroup select,\r\n.formGroup textarea {\r\n  width: 100%;\r\n  padding: 12px;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  transition: border-color 0.3s;\r\n}\r\n\r\n.formGroup input:focus,\r\n.formGroup select:focus,\r\n.formGroup textarea:focus {\r\n  border-color: #4CAF50;\r\n  outline: none;\r\n  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.1);\r\n}\r\n\r\n.buttonGroup {\r\n  display: flex;\r\n  gap: 15px;\r\n  margin-top: 25px;\r\n}\r\n\r\n.saveButton,\r\n.cancelButton {\r\n  padding: 12px 24px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  font-size: 1rem;\r\n  flex: 1;\r\n}\r\n\r\n.saveButton {\r\n  background-color: #4CAF50;\r\n  color: white;\r\n}\r\n\r\n.cancelButton {\r\n  background-color: #6c757d;\r\n  color: white;\r\n}\r\n\r\n.saveButton:hover {\r\n  background-color: #43a047;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.cancelButton:hover {\r\n  background-color: #5a6268;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n/* Адаптивные стили */\r\n@media (max-width: 768px) {\r\n  .container {\r\n    padding-top: 90px;\r\n  }\r\n\r\n  .table {\r\n    display: block;\r\n    width: 100%;\r\n    border-radius: 0;\r\n    box-shadow: none;\r\n  }\r\n\r\n  .table thead {\r\n    display: none;\r\n  }\r\n\r\n  .table tr {\r\n    display: block;\r\n    margin-bottom: 20px;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 10px;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.05);\r\n    padding: 15px;\r\n    background: #f9f9f9;\r\n  }\r\n\r\n  .table td {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 12px 10px;\r\n    border-bottom: 1px solid #eee;\r\n  }\r\n\r\n  .table td:last-child {\r\n    border-bottom: none;\r\n  }\r\n\r\n  .table td::before {\r\n    content: attr(data-label);\r\n    font-weight: 500;\r\n    margin-right: 15px;\r\n    flex-basis: 40%;\r\n    color: #495057;\r\n  }\r\n\r\n  .actionsCell {\r\n    display: flex;\r\n    gap: 8px;\r\n    justify-content: flex-end;\r\n  }\r\n\r\n  .modal {\r\n    padding: 20px;\r\n    border-radius: 12px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .header {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    padding: 15px 0;\r\n  }\r\n\r\n  .addButton {\r\n    width: 100%;\r\n    padding: 14px;\r\n    justify-content: center;\r\n  }\r\n\r\n  .formGroup input,\r\n  .formGroup select,\r\n  .formGroup textarea {\r\n    padding: 10px;\r\n  }\r\n\r\n  .buttonGroup {\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n\r\n  .saveButton,\r\n  .cancelButton {\r\n    width: 100%;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Organizations_container__jjP90`,
	"header": `Organizations_header__p6Qyn`,
	"title": `Organizations_title__-ceuV`,
	"addButton": `Organizations_addButton__Csa3x`,
	"table": `Organizations_table__FqdSF`,
	"actionsCell": `Organizations_actionsCell__yL4Os`,
	"leaderSearch": `Organizations_leaderSearch__ZbC2R`,
	"searchContainer": `Organizations_searchContainer__B+XqL`,
	"searchInput": `Organizations_searchInput__+w5Ct`,
	"searchResults": `Organizations_searchResults__9HZA6`,
	"searchResultItem": `Organizations_searchResultItem__fg6qM`,
	"loading": `Organizations_loading__fab4a`,
	"editButton": `Organizations_editButton__MrJj+`,
	"deleteButton": `Organizations_deleteButton__BM-4g`,
	"modalOverlay": `Organizations_modalOverlay__bK2-l`,
	"modal": `Organizations_modal__wB0lM`,
	"formGroup": `Organizations_formGroup__XxzsJ`,
	"buttonGroup": `Organizations_buttonGroup__3qzmB`,
	"saveButton": `Organizations_saveButton__yD4Cx`,
	"cancelButton": `Organizations_cancelButton__6JrrC`
};
export default ___CSS_LOADER_EXPORT___;
